import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


import {Modal} from 'bootstrap';


$('.discover').each(function () {

    if (inBackend) return;

    const $discover = $(this);
    const $header = $discover.find('.discover-header');
    const $body = $discover.find('.discover-body');
    const $arrow = $discover.find('.discover-arrow');

    // Init
    if ($discover.hasClass('closed')) {
        $body.hide();
    }


    $header.on('click', function (event) {
        event.preventDefault();
        toggle();
    });
    $arrow.on('click', function (event) {
        event.preventDefault();
        toggle();
    });

    function toggle() {
        if ($discover.hasClass('closed')) {
            $body.slideDown();
            $discover.removeClass('closed');
        } else {
            $body.slideUp();
            $discover.addClass('closed');
        }
    }
});
